import { Component, OnDestroy, OnInit, output } from '@angular/core';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { SHARED_IMPORTS } from '../../shared-imports';

@Component({
  selector: 'syn-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss'],
  imports: [SHARED_IMPORTS],
})
export class SearchbarComponent implements OnInit, OnDestroy {
  readonly changeSearch = output<string>();
  readonly launchSearch = output<void>();
  readonly resetSearch = output<void>();

  search: string;
  private _searchSubscription: Subscription;
  private readonly _searchChange: Subject<string> = new Subject<string>();
  private readonly _delayTime = 500;

  ngOnInit(): void {
    this._searchSubscription = this._searchChange
      .pipe(debounceTime(this._delayTime))
      .subscribe(() => {
        this.launch();
      });
  }

  ngOnDestroy(): void {
    this._searchSubscription.unsubscribe();
  }

  launch() {
    // TODO: The 'emit' function requires a mandatory void argument
    this.launchSearch.emit();
  }

  searchChanged() {
    if (this.search === '') {
      // TODO: The 'emit' function requires a mandatory void argument
      this.resetSearch.emit();
    } else {
      this.changeSearch.emit(this.search);
    }
    this._searchChange.next(this.search);
  }
}
